module.exports = __webpack_public_path__ + "64b3a9d87a5d8dae381fe3beee6f3f58.pdf";